jQuery(function($){
	$('.co-child-menu-mobile-expand').on('click', function(){
		let wasExpanded = $(this).hasClass('expanded');

		if(wasExpanded) {
			$(this).removeClass('expanded').closest('.co-section').find('.co-child-menu').removeClass('expanded');
		} else {
			$(this).addClass('expanded').closest('.co-section').find('.co-child-menu').addClass('expanded');
		}
	});
});